import { Link } from '@tanstack/react-router';
import { s } from '../strings';
import { buttonClass, Skeleton } from './ui';
import { IconPaw } from './icons';

export function PagePending() {
  return (
    <div className="flex flex-col gap-6" role="status" aria-label={s.common.loading}>
      <div className="flex flex-col gap-2">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-72 max-w-full" />
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        <Skeleton className="h-28" />
        <Skeleton className="h-28" />
        <Skeleton className="h-28" />
      </div>
      <Skeleton className="h-64" />
    </div>
  );
}

export function NotFound() {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center px-6 text-center">
      <div className="mb-5 flex size-14 items-center justify-center rounded-2xl bg-brand-tint text-brand" aria-hidden="true">
        <IconPaw size={28} />
      </div>
      <h1 className="text-2xl font-semibold">{s.common.notFoundTitle}</h1>
      <p className="mt-2 text-ink-muted">{s.common.notFoundBody}</p>
      <Link to="/" className={buttonClass('primary', 'md', 'mt-6')}>
        {s.common.goHome}
      </Link>
    </main>
  );
}
